import React, { useState, useEffect } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import './RequestCallBack.scss';

const OTPSection = ({
  enquiryId,
  mobileNumber,
  fullName,
  email,
  cityId,
  pincode,
  trackingData,
  otpPlaceholder,
  resendText,
  finalSubmitText,
  privacyConsent,
  marketingConsent,
  onVerified,
}) => {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);

  const [seconds, setSeconds] = useState(30);
  const [expired, setExpired] = useState(false);
  const [otpError, setOtpError] = useState('');
  const [showExpiredMsg, setShowExpiredMsg] = useState(false);
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';

  const getScooterSlug = () => {
    if (!pathname) return 'evscooter';

    const parts = pathname.split('/');
    return parts[2] || 'evscooter';
  };

  const scooterSlug = getScooterSlug();

  const API_BASE = `/electric-scooters/${scooterSlug}/api/VehicleFeatures/ProductFeatures`;

  useEffect(() => {
    if (otpError) {
      const timer = setTimeout(() => {
        setOtpError('');
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [otpError]);
  useEffect(() => {
    if (showExpiredMsg) {
      const timer = setTimeout(() => {
        setShowExpiredMsg(false);
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [showExpiredMsg]);

  // OTP Timer
  useEffect(() => {
    if (expired) return;

    if (seconds === 0) {
      setExpired(true);
      setShowExpiredMsg(true);
      return;
    }

    const timer = setTimeout(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [seconds, expired]);

  const handleVerifyOtp = async () => {
    if (otp.length !== 4) {
      setOtpError('Enter valid OTP');
      return;
    }

    setOtpError('');
    setLoading(true);

    const payload = {
      EnquiryId: enquiryId,
      OTP: otp,

      FullName: fullName,
      MobileNumber: mobileNumber,
      Email: email,

      CityId: cityId,
      PinCode: pincode,

      EnquiryType: 'QuickEnquiry',
      L2Source: 'QuickEnquiry',

      IsUserConsentTaken: true,
      IsMarketingConsentTaken: true,

      DeviceType: trackingData.DeviceType,
      CID: trackingData.CID,
      GCLID: trackingData.GCLID,
      GSessionID: trackingData.GSessionID,

      EnquiryMediaSource: {},
    };

    try {
      const res = await fetch(`${API_BASE}/EnquiryValidateOTP`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.success) {
        onVerified();
      } else {
        setOtpError(data.message || 'Invalid OTP');
      }
    } catch (error) {
      console.error(error);
      setOtpError('OTP verification failed');
    } finally {
      setLoading(false);
    }
  };

  // Resend OTP
  const handleResendOtp = async () => {
    try {
      const res = await fetch(`${API_BASE}/EnquiryResendOTP`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          MobileNumber: mobileNumber,
          EnquiryId: enquiryId,
        }),
      });

      const data = await res.json();

      if (data.success) {
        setOtp('');
        setSeconds(30);
        setExpired(false);
        setShowExpiredMsg(false);
        setOtpError('');
      } else {
        alert(data.message || 'Failed to resend OTP');
      }
    } catch (err) {
      console.error(err);
      alert('Error resending OTP');
    }
  };

  return (
    <div className="otp-content-wrapper">
      <div className="acceptance long-lable acceptance-bg">
        <label className="custom-checkbox ">
          <input type="checkbox" id="UserConsent" name="UserConsent" checked autoComplete="off" />
          <span className="checkmark"></span>
        </label>
        {privacyConsent && <RichText field={privacyConsent} tag="div" />}
      </div>
      <div className="acceptance long-lable form-group acceptance-bg">
        <label className="custom-checkbox">
          <input
            type="checkbox"
            name="MarketingConsent"
            id="MarketingConsent"
            checked
            readOnly
            autoComplete="off"
          />
          <span className="checkmark"></span>
        </label>

        {marketingConsent && <RichText field={marketingConsent} tag="div" />}
      </div>

      <div className="otp-wrapper">
        <div className="form-group otp">
          <div className="form-group otp-w">
            <input
              type="text"
              maxLength="4"
              value={otp}
              placeholder={otpPlaceholder}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '');
                setOtp(value);
                setOtpError('');
              }}
              className="form-control"
            />

            {otpError && <p className="text-danger error text-center">{otpError}</p>}

            {/* Timer UI you provided */}
            <div className="otp-timer">
              {expired ? (
                <button type="button" className="btn resend-btn" onClick={handleResendOtp}>
                  {resendText}
                </button>
              ) : (
                <span>Remaining: {seconds}s</span>
              )}
            </div>

            {showExpiredMsg && (
              <p className="text-danger error text-center" id="lblOTPtimeout">
                The OTP expired. Click &apos;Resend&apos; for a new one.
              </p>
            )}

            <div className="button-wrapper text-center">
              <button
                type="button"
                className="btn primary-gradient-btn"
                onClick={handleVerifyOtp}
                disabled={loading || otp.length !== 4 || expired}
              >
                {loading ? 'Submit' : finalSubmitText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTPSection;
